import React, { FC } from 'react';
import { Seo, PageLayout } from '../../components';
import { PageProps, Link } from 'gatsby';
import config from '../../../app-config.json';
import { MS_PaymentForm } from '../../components/Form';
import { Typography } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import { BodyWrap } from '../taher-scheme';
import { loadStripe, } from "@stripe/stripe-js";
import { siteMetadata } from '../../../gatsby-config';
// import * as s from '../../style.pages/index.style';
import { MetaDescription } from './';

const stripePromise = loadStripe(process.env.STRIPE_PUBLISH_KEY_MS!);
const PAGE_TITLE = config.pages.MOHAMMADI_SCHEME.routes.payentForm.title;
const PARENT_PAGE_TITLE = config.pages.MOHAMMADI_SCHEME.title
const PARENT_PAGE_PATH = config.pages.MOHAMMADI_SCHEME.path
const PAYMENT_FORM_PATH = config.pages.MOHAMMADI_SCHEME.routes.payentForm.path
export const PAYMENT_FORM_LINK = `${PARENT_PAGE_PATH}${PAYMENT_FORM_PATH}`;


const PaymentForm: FC<PageProps> = ({ }) => {
    return (
        <PageLayout>
            <Seo
                title={`${PAGE_TITLE} | ${PARENT_PAGE_TITLE} | ${siteMetadata.title}`}
                propMetaDescription={MetaDescription}
            />
            <Elements stripe={stripePromise}>
                <BodyWrap>
                    <br />
                    <Typography variant='h2' color='inherit' >Qardan Hasana Payment Form</Typography>
                    <Typography variant='h6' color='inherit' gutterBottom >QARDAN HASANA - {PARENT_PAGE_TITLE.toUpperCase()} (NON-REFUNDABLE)</Typography>
                    <hr /><br /> <br /> <br />
                    <MS_PaymentForm pageTitle={`${PARENT_PAGE_TITLE} - ${config.pages.MOHAMMADI_SCHEME.arbic_title}`} />
                    <br />

                </BodyWrap>
            </Elements>
        </PageLayout>
    )
}

export default PaymentForm;
